import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useIAChatMessagesStyles = makeStyles(() => ({
  messagesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  messageHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  messageHeaderRight: {
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
  },
  messageAvatar: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    objectFit: 'cover',
  },
  messageSender: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: 'normal',
    color: colors.chatMessageText,
  },
  messageTime: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    lineHeight: 'normal',
    color: colors.label,
  },
  messageSeparator: {
    fontSize: fontSize.base,
    color: colors.label,
    margin: '0 4px',
  },
  messageBubble: {
    padding: '12px 16px',
    borderRadius: radius.md,
    maxWidth: '85%',
    wordWrap: 'break-word',
  },
  userMessage: {
    padding: '12px 16px',
    borderRadius: radius.md,
    maxWidth: '85%',
    wordWrap: 'break-word',
    backgroundColor: colors.primary,
    color: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    alignSelf: 'flex-end',
    marginLeft: 'auto',
  },
  assistantMessage: {
    backgroundColor: colors.chatBubbleAssistant,
    color: colors.chatMessageText,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    alignSelf: 'flex-start',
    '& p': {
      margin: '0 0 12px 0',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& strong': {
      fontFamily: fonts.opensansSemiBold,
    },
    '& ul, & ol': {
      margin: '8px 0',
      paddingLeft: 24,
    },
    '& li': {
      marginBottom: 4,
    },
    '& h1, & h2, & h3, & h4': {
      fontFamily: fonts.opensansSemiBold,
      margin: '12px 0 8px 0',
    },
    '& a': {
      color: colors.primary,
    },
  },
}));
